// extracted by mini-css-extract-plugin
export default {"days":"Days_days__xuTYh","days-inner":"Days_days-inner__R+wh3","weekdays":"Days_weekdays__OJAUY"};